import { MetricDefinition } from '../../metrics/models/MetricDefinition';
import { ExplorableItemType, SpaceInfoItemType } from './ContentType';
import {
  ExplorableItemDefinition,
  MixedContentItemDefinition,
  SpaceDefinition
} from './contentDefinitions/ContentDefinitionsTypes';
import { AccelerationTaskDefinition } from './contentDefinitions/AccelerationTaskDefinition';
import { ExtractTaskDefinition } from './contentDefinitions/ExtractTaskDefinition';
import { PublishedConnectionDefinition } from './contentDefinitions/PublishedConnectionDefinition';
import { ProjectDefinition } from './contentDefinitions/ProjectDefinition';
import { WorkbookDefinition } from './contentDefinitions/WorkbookDefinition';
import { DatasourceDefinition } from './contentDefinitions/DatasourceDefinition';
import { DataRoleDefinition } from './contentDefinitions/DataRoleDefinition';
import { LensDefinition } from './contentDefinitions/LensDefinition';
import { ViewDefinition } from './contentDefinitions/ViewDefinition';
import { DataConnectionDefinition } from './contentDefinitions/DataConnectionDefinition';
import { FlowDefinition } from './contentDefinitions/FlowDefinition';
import { RunFlowTaskDefinition } from './contentDefinitions/RunFlowTaskDefinition';
import { CustomViewDefinition } from './contentDefinitions/CustomViewDefinition';
import { SubscriptionDefinition } from './contentDefinitions/SubscriptionDefinition';
import { DataAlertDefinition } from './contentDefinitions/DataAlertDefinition';
import { SiteDefinition } from './contentDefinitions/SiteDefinition';
import { ScheduleDefinition } from './contentDefinitions/ScheduleDefinition';
import { GroupDefinition } from './contentDefinitions/GroupDefinition';
import { WorkbookAccelerationDefinition } from './contentDefinitions/WorkbookAccelerationDefinition';
import { BackgroundJobDefinition } from './contentDefinitions/BackgroundJobDefinition';
import { FlowOutputStepRunDefinition } from './contentDefinitions/FlowOutputStepRunDefinition';
import { DatabaseDefinition, DatabaseWithCrassDefinition } from './contentDefinitions/DatabaseDefinition';
import { TableDefinition, TableWithCrassDefinition } from './contentDefinitions/TableDefinition';
import { DataConnectionInDatasourceDefinition } from './contentDefinitions/DataConnectionInDatasourceDefinition';
import { RemoteRefreshSchedulesDefinition } from './contentDefinitions/RemoteRefreshSchedulesDefinition';
import { ConnectedWorkbooksInDatasourceDefinition } from './contentDefinitions/ConnectedWorkbooksInDatasourceDefinition';
import { SiteUserDefinition } from './contentDefinitions/SiteUserDefinition';
import { ServerUserDefinition } from './contentDefinitions/ServerUserDefinition';
import { SearchUserDefinition } from './contentDefinitions/SearchUserDefinition';
import { RecommendedViewDefinition } from './contentDefinitions/RecommendedViewDefinition';
import { CollectionDefinition } from './contentDefinitions/CollectionDefinition';


export const MixedContentInOrder: MixedContentItemDefinition[] = [
  ProjectDefinition,
  WorkbookDefinition,
  ViewDefinition,
  MetricDefinition,
  DatasourceDefinition,
  FlowDefinition,
  DataRoleDefinition,
  LensDefinition,
  PublishedConnectionDefinition,
];

export const FavoriteMixedContentInOrder: MixedContentItemDefinition[] = [
  ProjectDefinition,
  WorkbookDefinition,
  ViewDefinition,
  MetricDefinition,
  DatasourceDefinition,
  FlowDefinition,
  DataRoleDefinition,
  CollectionDefinition,
  PublishedConnectionDefinition,
];

export const ExplorableItemDefinitions: Record<ExplorableItemType, ExplorableItemDefinition> = {
  project: ProjectDefinition,
  workbook: WorkbookDefinition,
  datasource: DatasourceDefinition,
  dataRole: DataRoleDefinition,
  lens: LensDefinition,
  view: ViewDefinition,
  dataconnection: DataConnectionDefinition,
  flow: FlowDefinition,
  customView: CustomViewDefinition,
  subscription: SubscriptionDefinition,
  accelerationTask: AccelerationTaskDefinition,
  extractTask: ExtractTaskDefinition,
  workbookAcceleration: WorkbookAccelerationDefinition,
  connection: DataConnectionInDatasourceDefinition,
  remoteRefreshSchedule: RemoteRefreshSchedulesDefinition,
  connectedWorkbook: ConnectedWorkbooksInDatasourceDefinition,
  flowOutputStepRun: FlowOutputStepRunDefinition,
  backgroundJob: BackgroundJobDefinition,
  databaseWithCrass: DatabaseWithCrassDefinition,
  tableWithCrass: TableWithCrassDefinition,
  database: DatabaseDefinition,
  table: TableDefinition,
  metric: MetricDefinition,
  siteuser: SiteUserDefinition,
  serveruser: ServerUserDefinition,
  searchuser: SearchUserDefinition,
  recommendedView: RecommendedViewDefinition,
  dataalert: DataAlertDefinition,
  site: SiteDefinition,
  schedule: ScheduleDefinition,
  runFlowTask: RunFlowTaskDefinition,
  group: GroupDefinition,
  collection: CollectionDefinition,
  publishedConnection: PublishedConnectionDefinition,
};

export const ContentSpaceDefinitions: { [C in SpaceInfoItemType]: SpaceDefinition<C> } = {
  project: ProjectDefinition,
  workbook: WorkbookDefinition,
  datasource: DatasourceDefinition,
  view: ViewDefinition,
  flow: FlowDefinition,
  dataRole: DataRoleDefinition,
  lens:LensDefinition,
  group: GroupDefinition,
  siteuser: SiteUserDefinition,
  serveruser: ServerUserDefinition,
  schedule: ScheduleDefinition,
  metric: MetricDefinition,
  collection: CollectionDefinition,
  publishedConnection: PublishedConnectionDefinition,
};
